import { Typography } from 'antd';
import styled from 'styled-components';
import { Menu as StyledMenu } from 'components/organisms/projects/project-sidebar/menu.style';
import { Caption01 } from 'components/styles';

export const SidebarWrapper = styled.div`
  padding-bottom: var(--spacing-06);
`;

export const SearchContainer = styled.div`
  background: #fff;
  padding: var(--spacing-05);
  padding-left: var(--left-spacing);
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const MenuContainer = styled.div``;

export const Title = styled(Typography.Text)`
  width: 192px;
`;

export const GroupTitle = styled(Typography.Text)`
  ${Caption01};
  color: var(--gray-80);
  width: 100px;
`;

export const Menu = styled(StyledMenu)`
  .ant-menu-item,
  .ant-menu-submenu-title {
    padding-left: var(--spacing-06) !important;
    padding-right: 0px;
  }

  .ant-menu-sub .ant-menu-item {
    font-weight: normal;
    padding-left: 70px !important;
    padding-right: 0;
  }
`;
export const MenuGroupItem = styled(Menu.ItemGroup)`
  .ant-menu-item-group-title {
    height: auto;
    padding: var(--spacing-05) 0 0 var(--spacing-06);
  }
`;
